import { useCallback, useState } from 'react';

export type UseForceUpdateReturnValue = {
    forceUpdate: () => void;
};

export function useForceUpdate() {
    const [, setTick] = useState(0);
    return {
        forceUpdate: useCallback(() => {
            setTick((tick) => tick + 1);
        }, []),
    };
}
